module.exports = new __parcel__URL__("united-kingdom.d84eb79c.png").toString();